import React from 'react';
import './Form.scss';

export default ({ children, header, ...props }) => (
	<form className="vl-form" {...props}>
		{header ? <h1 className="vl-form__header">{header}</h1> : null}
		{children}
	</form>
);
